import React from 'react';
import './compareValue.scss';
import { ReactComponent as RemoveIcon } from '../../ds/icons/svg/ontario-icon-remove-alt.svg';

const CompareValue = (props) => {
  return (
    <div className={`cviz-compare-value`}>
      <div className={`cviz-compare-value--icon`}>
        {props.name !== 'All Ontario' && props.name !== "Tout l'Ontario" && (
          <RemoveIcon
            className="ontario-icon"
            onClick={() => props.remOnClick(props.name)}
          />
        )}
      </div>
      <div className={`cviz-compare-value--label`}>
        <span
          dangerouslySetInnerHTML={{
            __html: props.label,
          }}
        />
      </div>

      {props.values.map((item, i) => {
        if (item !== undefined)
          return (
            <div className={`cviz-compare-value--value`} key={i}>
              <span
                dangerouslySetInnerHTML={{
                  __html: item + '%',
                }}
              />
            </div>
          );
      })}
    </div>
  );
};

export default CompareValue;
